import React from 'react';

export default function useDebounce(fn, deplay) {
  const timeoutRef = React.useRef(null);

  function debouncedFn(...args) {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      fn(...args);
    }, deplay);
  }
  return debouncedFn;
}
